import React, { useState } from "react";
import { Image } from "react-bootstrap";
import { useDispatch , useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import { fetchNDARequest } from "src/redux/actions/ndaTemplate";
import { NDA } from "src/types/nda";

import SwitchButton from "src/components/switchButton";
import Button from "src/components/button";
import Collapse from "src/pages/asset/components/animation/collapse";
import { Checkbox, InputWithIcon } from "src/components/input";
import DatePickerComponent from "src/components/datePicker";
import TimePicker from "src/components/timePicker";

import _ from "lodash";
import cx from "classnames";
import styles from "./advancedSettings.module.scss";
import userRoleService from "src/utils/userRoles.service";


const noNDA  = "/images/no_template.svg";
interface AdvancedSettingsProps {
  onToggle: (key: string, value?:any) => void;
  emailRequestState: { [key: string]: any };
  onSelection : (key: string, value?:any) => void;
  advancedSettings : boolean;
  handleAdvancedSettings: () => void;
  onClose: () => void;
  isDealRoom?: boolean;
}

const AdvancedSettings: React.FC<AdvancedSettingsProps> = ({ onToggle, emailRequestState, isDealRoom = false, onSelection , advancedSettings ,handleAdvancedSettings, onClose }) => {

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const [enablePassword, setEnablePassword] = useState(false);
  const [expiryEnabled, setExpiryEnabled] = useState(false);
  const [enableNDA, setEnableNDA] = useState(false);
  const [inputType, setInputType] = useState<string>("password");
  const [expiryDate, setExpiryDate] = useState<any>();
  const [time, setTime] = useState<any>();
  const [password, setPassword] = useState('');

  const nda = useSelector((state: any) => _.get(state, "nda", {}));

  const renderInputIcon = () => {
    if (!password) {
      return "";
    }
    return inputType !== "password" ? "paperflite-eye" : "paperflite-hidden-eye";
  };

  const toggleInput = () => {
    if (!password) {
      setPassword("");
    } else {
      setInputType(inputType === "text" ? "password" : "text");
    }
  };

  const handleChangeExpiryDate = (date: any) => {
    const selectedDate = moment(date).format("DD MMM YYYY");
    setExpiryDate(selectedDate);
    if (!time) {
      setTime(selectedDate);
    }
  };

  const handleTimeChange = (time: any) => {
    setTime(time);
    if (!expiryDate) {
      setExpiryDate(new Date());
    }
  };

  const handleToggleNDA = () => {
    setEnableNDA((enableNDA) => {
      dispatch(fetchNDARequest());
      return !enableNDA;
    });
  };

  return (
    <div className={styles.container}>
      <div className={styles.header} onClick={handleAdvancedSettings}>
        <i className={advancedSettings ? "paperflite-close" : "paperflite-settings"}></i>
        <div className={styles.text}>
          {advancedSettings ? "hide advanced settings" : "show advanced settings"}
        </div>
      </div>
      <Collapse isOpen={advancedSettings}>
        <div className={styles.body}>
          <div className={styles.row}>
            <div className={styles.options}>
              <div className={styles.title}>Allow recipients to download</div>
              <SwitchButton
                id="canDownload"
                className={styles.switch}
                checked={emailRequestState.canDownload}
                handleCheck={() => onToggle("canDownload")}
              />
            </div>
            <Collapse isOpen={emailRequestState.canDownload}>
              <div className={styles.optionsContainer}>
                <div className={styles.optionsRow}>
                  <Checkbox
                    label="Editable"
                    checked={emailRequestState.downloadEditable}
                    className={styles.check}
                    type="radio"
                    onChange={() => onToggle("downloadEditable")}
                  />
                </div>
                <div className={styles.optionsRow}>
                  <Checkbox
                    label="Read only"
                    type="radio"
                    className={styles.check}
                    checked={!emailRequestState.downloadEditable}
                    onChange={() => onToggle("downloadEditable")}
                  />
                </div>
                <div className={styles.disclaimer}>
                  *This applies to PPTs, Docs, Google Slides and Google Docs.
                </div>
              </div>
            </Collapse>
          </div>

        {!isDealRoom && <>
         <div className={styles.row}>
            <div className={styles.options}>
              <div className={styles.title}>Allow recipients to reshare</div>
              <SwitchButton
                id="canReshare"
                className={styles.switch}
                checked={emailRequestState.canReshare}
                handleCheck={() => onToggle('canReshare')}
              />
            </div>
          </div>
          {userRoleService.canAccessEngage() && !userRoleService.isEngageViewOnly() && <div className={styles.row}>
            <div className={styles.options}>

              <div className={styles.title}>Enable engage</div>
              <SwitchButton
                id="engage"
                className={styles.switch}
                checked={emailRequestState.engage}
                handleCheck={() => onToggle('engage')}
              />
            </div>
          </div>}

          <div className={styles.row}>

            <div className={styles.options}>

              <div className={styles.title}>Set an password</div>
              <SwitchButton
                id="password"
                className={styles.switch}
                checked={enablePassword}
                handleCheck={() => {
                  onSelection("isPasswordEnabled",!enablePassword)
                  setEnablePassword(!enablePassword)
                }
                }
              />
            </div>
            <Collapse isOpen={enablePassword}>
              <div className={styles.inputContainer}>
                <InputWithIcon
                  value={password}
                  placeholder="Enter password"
                  type={inputType}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    onSelection("password", e.target.value)
                  }}
                  onIconClick={toggleInput}
                  className={styles.passwordInput}
                  icon={renderInputIcon()}
                />
              </div>
            </Collapse>
          </div>

          <div className={styles.row}>

            <div className={styles.options}>
              <div className={styles.title}>Set an expiry date & time</div>
              <SwitchButton
                id="expiryDate"
                className={styles.switch}
                checked={expiryEnabled}
                handleCheck={() => {
                  onSelection("isExpiryEnabled",!expiryEnabled)
                  setExpiryEnabled(!expiryEnabled)
                }}
              />
            </div>
            <Collapse isOpen={expiryEnabled}>
              <div className={styles.datePickerContainer}>
                <DatePickerComponent
                  value={expiryDate && moment(expiryDate).format("DD MMM YYYY")}
                  handleDateChange={(date) => {
                    const formattedDate = moment(date).format("YYYY-MM-DDTHH:mm:ss.SSS[Z]");
                    handleChangeExpiryDate(formattedDate);
                    onSelection?.('expiryDate', formattedDate);
                  }}
                  minDate={moment().startOf("day").toDate()}
                  customInput={<InputWithIcon icon="paperflite-calendar" />}
                  className={styles.datePicker}
                />
                <TimePicker
                  value={time ? moment(time).format("hh:mm A") : "pick a time"}
                  onChange={handleTimeChange}
                />
              </div>
            </Collapse>
          </div>
          <div className={styles.row}>
            <div className={styles.options}>
              <div className={styles.title}>Enable NDA</div>
              <SwitchButton
                id="nda"
                className={styles.switch}
                checked={enableNDA}
                handleCheck={handleToggleNDA}
              />
            </div>

            {nda.fetching && !nda.fetched && (
              <NDAPlaceholder />
            )}

            {!nda.fetching && (

              <Collapse isOpen={enableNDA} config={{ tension: 0, friction: 0 }} >
                <div className={styles.ndaContainer}>
                  <div className={styles.optionsContainer}>
                    {_.size(nda.items) === 0 && (

                      <div className={styles.emptyMessage}>
                        <Image src={noNDA} width={150} height={150} />
                        <span className={styles.title}>
                          Type less, Share more
                        </span>
                        <span className={styles.subTitle}>
                          Create reusable NDA templates for you and your teams.
                        </span>
                        <Button
                          variant="primary"
                          icon="paperflite-add"
                          text="Create New"
                          className={styles.createNDA}
                          onClick={() => {
                            onClose();
                            navigate("/settings/nda-templates/new");
                          }}
                        />
                      </div>
                    )}
                    {_.size(nda.items) !== 0 &&
                      nda.items.map((ndaItem: NDA) => (
                        <div key={ndaItem.id} className={styles.optionsRow}>
                          <Checkbox
                            label={ndaItem.name || ""}
                            className={styles.check}
                            type="radio"
                            checked={emailRequestState.nda === ndaItem.id}
                            onChange={() => {
                              onSelection("nda", ndaItem.id);
                            }}
                          />
                        </div>
                      ))}
                  </div>
                </div>
              </Collapse>
            )}
          </div>
          </>
          }
        </div>
      </Collapse>
    </div>
  )
};

export default AdvancedSettings;


export const NDAPlaceholder: React.FC = () => {
  return (
    <div className={styles.loaders}>
      {_.times(4, (index) => (
        <div className={cx(styles.nda, styles.placeholder)} key={index}>
          <span className={cx(styles.checkbox, styles.block)} />
          <span className={cx(styles.name, styles.block)} />
        </div>
      ))}
    </div>
  );
}